import React from 'react';
import { cx } from '../utils';
import './Field.css';

export const hintId = (id) => `${id}-hint`;
export const errorId = (id) => `${id}-error`;

// Input/Textarea/Select uchun umumiy o'rama: label, hint va error matni.
// error berilsa hint o'rniga ko'rsatiladi.
function Field({ id, label, hint, error, required, className, children }) {
  return (
    <div className={cx('ui-field', className)}>
      {label && (
        <label htmlFor={id} className="ui-field__label">
          {label}
          {required && (
            <span className="ui-field__required" aria-hidden="true">
              *
            </span>
          )}
        </label>
      )}
      {children}
      {error ? (
        <p id={errorId(id)} className="ui-field__error">
          {error}
        </p>
      ) : (
        hint && (
          <p id={hintId(id)} className="ui-field__hint">
            {hint}
          </p>
        )
      )}
    </div>
  );
}

export default Field;
